module.exports = __webpack_public_path__ + "img/house.1172f370.svg";